import { _breakP } from './utils.js';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

export default class Movie {
  constructor() {
    this.movieAction();
  }

  movieAction() {
    const $movieModal = document.querySelectorAll('.js-movieModal');
    if (!$movieModal.length) return;

    function modalContDOMMove(e, i) {
      const $modalDomMovedPoint = document.querySelector('.currentPage');
      const $modalCont = e.querySelector('.js-movieModalCont');
      if (!$modalDomMovedPoint || !$modalCont) return null;
      $modalCont.classList.add(`js-movieModalCont--${i}`);
      // Move the existing DOM node directly to avoid HTML re-serialization
      // (insertAdjacentHTML / outerHTML round-trip is an XSS sink and loses listeners).
      $modalDomMovedPoint.prepend($modalCont);
      return $modalCont;
    }

    $movieModal.forEach((modalElm, index) => {
      const modalStruct = () => {
        const $modalCont = modalContDOMMove(modalElm, index);
        if (!$modalCont) return;
        const $modalBtn = modalElm.querySelectorAll('.js-movieModalBtn');
        const $closeBtn = $modalCont.querySelectorAll('.js-movieModalClose');
        const $video = $modalCont.querySelector('.js-movieFrame');
        let $lastFocusedElm;
        let escapeHandler = null;

        const modalClose = () => {
          if ($lastFocusedElm) $lastFocusedElm.focus();
          $modalCont.classList.remove('is-visible');
          $modalCont.setAttribute('aria-hidden', 'true');
          $modalCont.setAttribute('aria-modal', 'false');
          $modalCont.setAttribute('hidden', 'hidden');
          for (let i = 0; i < $modalBtn.length; i++) {
            $modalBtn[i].setAttribute('aria-expanded', 'false');
          }
          for (let i = 0; i < $closeBtn.length; i++) {
            $closeBtn[i].setAttribute('aria-hidden', 'true');
            $closeBtn[i].setAttribute('tabindex', '-1');
          }
          clearAllBodyScrollLocks();
          document.documentElement.style.overflow = '';

          if (escapeHandler) {
            document.removeEventListener('keydown', escapeHandler);
            escapeHandler = null;
          }

          if ($video) {
            $video.pause();
            $video.currentTime = 0;
          }
        };

        const modalOpen = () => {
          $lastFocusedElm = document.activeElement;
          $modalCont.classList.add('is-visible');
          $modalCont.setAttribute('aria-hidden', 'false');
          $modalCont.setAttribute('aria-modal', 'true');
          $modalCont.removeAttribute('hidden');

          const $target = $modalCont.querySelector('.js-movieModalInner');
          for (let i = 0; i < $modalBtn.length; i++) {
            $modalBtn[i].setAttribute('aria-expanded', 'true');
          }
          for (let i = 0; i < $closeBtn.length; i++) {
            $closeBtn[i].setAttribute('aria-hidden', 'false');
            $closeBtn[i].setAttribute('tabindex', '0');
          }

          const $focusItem = $modalCont.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
          setTimeout(() => {
            if ($focusItem[0]) $focusItem[0].focus();
          }, 10);

          $modalCont.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
              if (document.activeElement === $focusItem[$focusItem.length - 1] && !event.shiftKey) {
                event.preventDefault();
                $focusItem[0].focus();
              }
            }
          });

          escapeHandler = (event) => {
            if (event.key === 'Escape' && $modalCont.classList.contains('is-visible')) {
              modalClose();
            }
          };
          document.addEventListener('keydown', escapeHandler);

          if ($target) disableBodyScroll($target);
          document.documentElement.style.overflow = 'hidden';

          if ($video) {
            $video.currentTime = 0;
            const playPromise = $video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }
        };

        $modalCont.setAttribute('id', `movie-modal-${index}`);

        $modalBtn.forEach((elm) => {
          elm.setAttribute('aria-controls', `movie-modal-${index}`);
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            modalOpen();
          });
        });

        $closeBtn.forEach((elm) => {
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            modalClose();
          });
        });
      };

      const modalDisable = () => {
        const $modalBtn = modalElm.querySelectorAll('.js-movieModalBtn');
        for (let i = 0; i < $modalBtn.length; i++) {
          $modalBtn[i].setAttribute('tabindex', '-1');
        }
        const $modalCont = modalElm.querySelector('.js-movieModalCont');
        if ($modalCont) $modalCont.classList.add('is-disable');
      };

      if (modalElm.dataset.modalDevice === 'sp') {
        _breakP.SP ? modalStruct() : modalDisable();
      } else if (modalElm.dataset.modalDevice === 'pc') {
        !_breakP.SP ? modalStruct() : modalDisable();
      } else {
        modalStruct();
      }
    });
  }
}
